import { DialogWrapper, DialogWrapperProps } from "components/shared/dialog";
import { ObjectPermissionSetData } from "types/permissions";

export interface ChangeConfDialogProps extends DialogWrapperProps {
  permission: ObjectPermissionSetData;
}

export const ChangeConfDialog = (props: ChangeConfDialogProps) => {
  const { permission } = props;

  return (
    <DialogWrapper
      {...props}
      title={props.title || "Confirm Your Action"}
      onClose={(event, reason) => {
        if (reason && reason === "backdropClick") return false;
        if (props.onClose) props?.onClose(event, reason);
      }}
      onSubmit={props.onSubmit}
      submitText="Confirm"
    >
      {!permission.objectPermissionValue && (
        <div>
          If <span style={{ fontWeight: "bolder" }}>Changeable</span> is
          disabled, then the users card page content will be overwritten with
          the Enterprise content.
        </div>
      )}

      {permission.objectPermissionValue && (
        <div>
          If <span style={{ fontWeight: "bolder" }}>Changeable</span> is
          enabled, then the users card page content will NOT be overwritten with
          the Enterprise content.
        </div>
      )}
    </DialogWrapper>
  );
};
